module.exports = __webpack_public_path__ + "img/img_idcard.bdd441c5.png";